import { clsx } from "@trydig/ui";
import { Fragment } from "react";
import { Chevron } from "~/components/icons/Chevron";
import { Link } from "~/i18n/routing";
import styles from "./Breadcrumbs.module.css";

export const Breadcrumbs = ({ crumbs }: { crumbs?: { name?: string; uri?: string }[] }) => {
	if (!crumbs) return null;

	return (
		<nav className={styles.breadcrumbs} data-layout="blok">
			{crumbs?.map((crumb, i) => (
				<Fragment key={i}>
					{i !== 0 && <Chevron direction={"right"} />}
					<Link
						className={clsx(i === crumbs.length - 1 && styles.crumb__inactive)}
						key={i}
						href={crumb?.uri || "/"}
					>
						{crumb?.name}
					</Link>
				</Fragment>
			))}
		</nav>
	);
};
